/* @flow */
import * as React from "react";
import { withColorsProvider, type ColorSet } from "../../ColorsProvider";
import NumericUpDownPicker from "../../NumericUpDownPicker";

type Props = {
  colors: ColorSet,
  onUp: () => void,
  onDown: () => void,
  upDisabled?: ?boolean,
  downDisabled?: ?boolean,
  kind: "heat" | "cool",
  value: number,
};

class SetpointPicker extends React.Component<Props> {
  render() {
    const {
      colors,
      onUp,
      onDown,
      upDisabled,
      downDisabled,
      kind,
      value,
    } = this.props;

    const kindStyles = {
      heat: {
        color: colors.HEAT,
      },
      cool: {
        color: colors.COOL,
      },
    };

    return (
      <NumericUpDownPicker
        onUp={onUp}
        onDown={onDown}
        upDisabled={upDisabled}
        downDisabled={downDisabled}
        style={kindStyles[kind]}
      >
        <span>
          {value}
          {"°"}
        </span>
      </NumericUpDownPicker>
    );
  }
}

export default withColorsProvider(SetpointPicker);



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/TileControls/SetpointPicker.jsx